// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_Wea","cls2":"BulkFollowListModal-cls2__su BulkFollowListModal-cls1_Wea"};